import axios from 'axios';

const STORE_URL = 'https://happyboxstore.com';
const COLLECTION_HANDLE = 'build-a-happy-box';
const MAIN_PRODUCT_TYPE = 'Box';
const ADDON_PRODUCT_TYPE = 'Gift';
const CARD_PRODUCT_TYPE = 'Card';

const actions = {
    getCuratedBox(context){
        var url = window.location.pathname.split('/');
        var handle = url[url.length - 1];
        axios.get(`/products/${handle}.js`)
        .then(response => response.data)
        .then((data) => {
          context.commit('setCuratedBox', data);
          let minQtyTag = data.tags.find(x => x.includes("QTYMIN_"))
          if(minQtyTag){
            let minQTy = minQtyTag.split("_")[1];
            context.commit('setMinQty', parseInt(minQTy));
          }
        })
        .catch((err) => {
          console.log('***Error Fetching Curated Box***');
        });
        axios.get(`${STORE_URL}/cart.js`)
        .then(response => response.data)
        .then((data) => {
          context.commit('setCart', data);
        })
    }
  }

export default actions;
